import { Input, Modal, ModalBody } from "reactstrap";
import styles from "./index.module.scss";
import { useEffect, useState } from "react";

const AddTitleModal = (props) => {
  const { open, setOpen, handleSave } = props;
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (open) {
      setTitle("");
    }
  }, [open]);

  return (
    <Modal
      isOpen={open}
      toggle={setOpen}
      backdrop
      size="sm"
      backdropClassName={styles["reverted-backdrop"]}
      className={styles["supporter-registration-modal"]}
      style={{
        width: "440px",
      }}
    >
      <ModalBody>
        <div
          style={{
            fontSize: "20px",
            marginBottom: "100px",
            textAlign: "center",
            marginTop: "72px",
          }}
        >
          条件保存
        </div>
        <div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              marginBottom: "8px",
            }}
          >
            案件名・企業
          </div>
          <Input
            type="text"
            name="searchContidionName"
            placeholder="テキスト"
            style={{
              display: "block",
            }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <button
            style={{
              marginTop: "16px",
              width: "100%",
              color: "#fff",
              backgroundColor: "#44CAE1",
              padding: "12px",
              borderRadius: "4px",
              border: "none",
              marginBottom: "100px",
            }}
            onClick={() => {
              handleSave(title);
              setOpen(false);
            }}
          >
            保存
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddTitleModal;
